var map = {
	"./": 5312,
	"./applicationName": 401,
	"./applicationName.js": 401,
	"./applicationVersion": 1711,
	"./applicationVersion.js": 1711,
	"./index": 5312,
	"./index.js": 5312,
	"./live": 2651,
	"./live.js": 2651,
	"./local": 9178,
	"./local.js": 9178,
	"./stg": 2531,
	"./stg.js": 2531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 938;